export default {
  computed: {
    formError: function () {
      return (field) => this.$store.getters['form/error'](field)
    },
    hasFormErrors: function () {
      return Object.keys(this.$store.getters['form/errors']).length > 0
    }
  }
}
